import { css, keyframes } from "styled-components";
import { duration, easing } from "./transitions";

/**
 * Content taking over from its skeleton: a short fade and rise from the motion
 * tokens. It starts part-visible, so the swap never reads as a blank flash.
 */
const reveal = keyframes`
  from {
    opacity: 0.35;
    transform: translateY(0.25rem);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;

export const contentRevealMotion = css`
  animation: ${reveal} ${duration.normal} ${easing.smooth} both;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
